module.exports = __webpack_public_path__ + "static/media/asset_thumbsup.e89e14d7.svg";